/**
 * Solo is played offline, so the server never sees it and the boards don't count it; its record lives on
 * the device instead, said as such («соло-рекорд»), so a first match is never simply lost.
 */
export interface SoloRecord { best: number; bosses: number; matches: number }
const KEY = 'orb.solo';

export function soloRecord(): SoloRecord {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) ?? 'null');
    if (v && Number.isFinite(v.best)) return { best: v.best | 0, bosses: v.bosses | 0, matches: v.matches | 0 };
  } catch { /* private mode, or junk */ }
  return { best: 0, bosses: 0, matches: 0 };
}

/** Count a finished solo match; returns the record before it (for «Новий соло-рекорд»). */
export function keepSolo(kills: number, bosses: number): number {
  const r = soloRecord(), before = r.best;
  try { localStorage.setItem(KEY, JSON.stringify({ best: Math.max(r.best, kills), bosses: r.bosses + bosses, matches: r.matches + 1 })); } catch { /* not kept */ }
  return before;
}
